<template>
  <div>
    <el-row class="bottom20">
      <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
        <el-table-column>
          <template slot="header" slot-scope="scope">
            内容编号<br>
            <el-input size="mini" v-model="pageSearch.search.like_jpnum" placeholder="内容编号"></el-input>
          </template>
          <template slot-scope="scope">
            <a href="javascript: void(0);" @click.self="look(scope.row)">{{scope.row.jpnum}}</a>
          </template>
        </el-table-column>

        <el-table-column>
          <template slot="header" slot-scope="scope">
            数据中心<br>
            <dictionary-select v-model="pageSearch.search.eq_deptid" :factory-name="'department'" :params="{type: 'JOB_PLAN'}" clearable filterable size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'department'" :params="{type: 'JOB_PLAN'}" :value="scope.row.deptid"></dictionary-text>
          </template>
        </el-table-column>

        <el-table-column>
          <template slot="header" slot-scope="scope">
            内容名称<br>
            <el-input size="mini" v-model="pageSearch.search.like_description" placeholder="请输入内容名称"></el-input>
          </template>
          <template slot-scope="scope">
            {{scope.row.description}}
          </template>
        </el-table-column>

        <el-table-column prop="workType">
          <template slot="header" slot-scope="scope">
            类型<br>
            <domain-select size="mini" v-model="pageSearch.search.eq_type" :domainid="'JOBPLANTYPE'" clearable></domain-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'JOBPLANTYPE'" :value="scope.row.type"></dictionary-text>
          </template>
        </el-table-column>

        <el-table-column>
          <template slot="header" slot-scope="scope">
            录入人员<br>
            <el-input size="mini" v-model="pageSearch.search.like_enterbyname" placeholder="录入人员"></el-input>
          </template>
          <template slot-scope="scope">
            {{scope.row.enterbyname}}
          </template>
        </el-table-column>

        <el-table-column prop="enterdate">
          <template slot="header" slot-scope="scope">
            录入时间<br>
            <div style="height: 40px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.enterdate}}
          </template>
        </el-table-column>

        <el-table-column>
          <template slot="header" slot-scope="scope">
            状态<br>
            <dictionary-select v-model="pageSearch.search.eq_status" :factory-name="'domain'" :params="'3PSTATUS'" clearable size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'3PSTATUS'" :value="scope.row.status"></dictionary-text>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
  import { debounce } from "@/util/common"
  import DomainSelect from '@/components/domainaln'
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import DeptSelect from '@/components/dept'
  import {selected, visited, page} from  '../mixins/table'
  import {WorkOrderServer} from  '@/api'

  import { dictionaryContainer, Dictionary } from '@/util/common/dictionary'

  export default {
    name: "JobplanList",
    mixins: [selected, visited, page],
    components: {
      DictionarySelect,
      DictionaryText,
      DomainSelect,
      DeptSelect
    },
    data() {
      return {
        key: 'jobplanid',
        statusDictionay: new Dictionary({
            items: [{
              value: '0',
              text: '草稿'
            }, {
              value: '1',
              text: '活动'
            }, {
              value: '2',
              text: '不活动'
            }]
        }),
        pageSearch: {
          search: {
            like_jpnum: '',
            eq_deptid: '',
            like_description: '',
            eq_type: '',
            like_enterbyname: '',
            eq_status: '',

            eq_priority: '',
            eq_isstandard: '',
            // eq_assettype: '',
            cts_assettype: '',
            like_equipmenttype: '',
            ge_releasedate: '',
            le_releasedate: '',
            ge_enterdate: '',
            le_enterdate: '',
          }
        }
      };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
      look(data) {
        console.log('list show detail ...');
        this.select(data);
        this.visit(data);
        this.$emit('switch-tab', 'detail');
        this.$emit('switch-operation', 'detail.show');
      },
      queryByPage: debounce(function(pageSearch) {
        console.log(`Sop query by page...`, pageSearch);

        WorkOrderServer.jobPlan.page(pageSearch).then((res) => {
          if (res.data.code === 200) {
            this.page = {
              total: res.data.result.total,
              records: res.data.result.records,
            };
          }
        });
      }, 500),
    },
  }
</script>

<style scoped>

</style>
